export const CONFIG_DATA = {
  desktop: 'C-A-447162-70',
  mobile: 'C-A-447162-71'
};
